/**
 * @file iconFlagCell.js
 * @project Web-panel
 * @author Pavel Shabardin (<bigbn@mail.ru>) Friday, 10th January 2020 10:11:20 am
 * @copyright 2015 - 2020 SKAT LLC, Delive LLC
 * @flow
 */

import * as React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import moize from 'moize'
import { genTestName, genCellTestMarks } from 'web-panel/globals'

const Icon = moize.react(({ name }) => (<FontAwesomeIcon className='icon half-right-margin' icon={name} />))

function IconFlagCell ({ grid, className, column, record, columnIndex, rowIndex, style, onContextMenu, onDoubleClick, onClick, value, title }: any) : React.Node {
  style = {
    ...style,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexDirection: 'row'
  }

  const icon = this.icon
  const reverseIcon = this.reverseIcon

  let representField = record[this.referenceField]
  if (this.mode && this.mode === 'reverse') representField = !representField

  return (
    <div
      {...genTestName(column.name, grid.testName)}
      {...genCellTestMarks(rowIndex, columnIndex)}
      className={className}
      style={style}
      title={title}
      onContextMenu={(event) => onContextMenu({ event, record, column, columnIndex, rowIndex })}
      onDoubleClick={(event) => onDoubleClick({ event, record, column, columnIndex, rowIndex })}
      onClick={(event) => onClick({ event, record, column, columnIndex, rowIndex })}
    >
      {representField ? <Icon name={icon} /> : reverseIcon ? <Icon name={reverseIcon} /> : null} {value}
    </div>
  )
}

export default IconFlagCell
